// material-ui
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

// project imports
import logo from 'assets/images/logo.png';

// ==============================|| LOGO ||============================== //

export default function LogoMain() {
  return (
    <Stack direction="row" sx={{ alignItems: 'center', gap: 1 }}>
      <img src={logo} alt="" width={35} height={35} style={{ display: 'block' }} />
      <Typography variant="h4" component="span" sx={{ fontWeight: 700, color: 'text.primary' }}>
        Summa
      </Typography>
    </Stack>
  );
}
